import React from "react";

const CardsComponent = ({ title, description, image, className, tdClass, imgClass }) => {
    return (
        <div className={`d-flex ${className} gap-3`}>
            <div className={`${tdClass}`}>
                <h3>{title}</h3>
                <p>{description} <span> Read More</span></p>
            </div>
            <div className={`${imgClass}`}>
                <img src={image} alt={title} className="img-fluid" />
            </div>
        </div>
    );
};

export default CardsComponent;
